"use client";

import Link from "next/link";
import { ShoppingBag } from "lucide-react";

interface EmptyCartStateProps {
  onNavigate?: () => void;
}

export function EmptyCartState({ onNavigate }: EmptyCartStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4">
      <ShoppingBag size={40} style={{ color: "#3A3A3A" }} />
      <p className="text-sm text-center" style={{ color: "#9A9A9A" }}>
        Your cart is empty.
      </p>
      <Link
        href="/shop"
        onClick={onNavigate}
        className="text-sm font-semibold px-5 py-2.5 rounded-sm transition-all hover:brightness-110"
        style={{ backgroundColor: "#E8C547", color: "#0A0A0A" }}
      >
        Shop All Strings
      </Link>
    </div>
  );
}
